import { Serializable } from './serializable';

//TODO: Revisar los status
export enum ORDER_STATUS {
  PAYMENT_PENDING = 10,
  PROCESSING = 20,
  BENEFICIARY_CAN_COLLECT = 30,
  COLLECTED_BY_BENEFICIARY = 40,
  CANCELLED = 50,
  REFUNDED = 60,
  AVAILABLE_TO_REFUND = 70,
  COMPLETED = 80,
  EXPIRED = 90,
  UNFUNDED = 100,
  PAYID_DEREGISTERED = 110,
  PENDING = 120,
}

export enum TRANSACTION_STATUS {
  PENDING = 'Pending',
  PENDING_FUNDS = 'Pending Funds',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled'
}

export enum ORDER_STATUS_DISPLAYED {
  IN_PROCESS = 0,
  IN_REVIEW = 1,
  CANCELED = 2,
  TO_CANCEL = 3,
  READY_FOR_PICKUP = 4,
  DEPOSIT_IN_TRANSIT = 5,
  DEPOSITED = 6,
  DELIVERY_IN_TRANSIT = 7,
  DELIVERED = 8,
  PAID = 9,
  VERIFY = 10,
  RESEND = 11,
  UNFUNDED = 12,
  CONFIRMATION_EXPIRED = 13,
  PENDING = 14,
  REFUNDED = 15,
  DOCUMENT_REQUIRED = 16,
  DOCUMENT_REVIEW = 17,
  DOCUMENT_RESUBMIT = 18
}

export const TRANSACTION_CATEGORY_TYPE = {
  FUND_TRANSFER: 10,
  PROCESSING: 20,
  READY_FOR_PICKUP: 30,
  PROCESSING_REFUND: 40,
  MONEY_RECEIVED: 50,
  TRANSFER_CANCELLED: 60,
  REQUEST_CANCELLED: 70,
}

export const TransactionViewType = {
  Full: 'Full',
  Condensed: 'Condensed',
  Any: 'Any'
}

export class TransactionV3 extends Serializable {
  public Transactions: [Transaction];
  public AppReviewEligibiliy: AppReviewEligibility;
  public IsTransactionalNPSNeeded?: boolean;
}

export class AppReviewEligibility extends Serializable {
  Eligible: boolean;
}

export class Transaction extends Serializable {
    public Id: number;
    public OrderNo: string;
    public Pin: string;
    public StatusId: ORDER_STATUS;
    public OrderStatusDisplayed: ORDER_STATUS_DISPLAYED;
    public NotProcessed: boolean;
    public CustomerId: number;
    public Date: any;
    public EnteredTime: Date;
    public PaidTime: Date;
    public CancelledTime: Date;
    public Voided: boolean;
    public BankAccountNo: string;
    public BankName: string;
    public BenNameId: number;
    public BenId: number;
    public BeneficiaryFirstName: string;
    public BeneficiaryFirstLastName: string;
    public DelivMethod: number;
    public DelivMethodName: string;
    public AmountLocal: number;
    public AmountSentLocal: number;
    public TransferAmount: number;
    public TransferReason: number;
    public TotalAmount:number;
    public Commission: number;
    public TaxAmount: number;
    public Surcharge: number;
    public CountryTo: string;
    public CountryFrom: string;
    public Currency: string;
    public PaymentCurrency: string;
    public DateAvailablePayout: Date;
    public PayAgentId: number;
    public PayAgentLocId: number;
    public RecAgentId: number;
    public RecAgentLocId: number;
    public Barcode: string;
    public PayID: string;
    public BeneficiarySecondLastName: string;
    public Cancellable: boolean;
    public CanResend: boolean;
    public ExpirationDate: Date
    public PayAddressLine1: string;
    public PayAddressLine2: string;
    public PayCity: string;
    public PayCountry: string;
    public PayPostalCode: string;
    public PostalAddress: string;
    public RefundDatetime: Date;
    public TransfReason: number;
    public OriginalCustomerCharge: number;
    public IsOpenCountry: boolean;
    public IsOpenNetwork: boolean;
    public PayAgentName: string;
    public PaymentMethod: number;
    public OrderStatusCategory: number;
    public UploadRequestNo : number;
    public UploadReason: string;
    public UploadDocTypes: [string];
    public UploadDocumentInfo: UploadDocumentInfo[];
    public ShownOrderStatus?: string;
    public PayNowDetails: PayNowDetails;
    public IsLoading?: boolean;
    public SmartRoutingEntityId?: number; 
}

export class WalletTransaction extends Serializable {
  public TransactionAmount: number;
  public TransactionCurrency:  string;
  public TransactionReferenceNumber: string;
  public TransactionDescription: any;
  public TransactionDateTime: string;
  public TransactionType: any;
  public TransactionStatus: WalletTransactionStatus;
  public BillPaymentDetails: BillPaymentDetails;
  public DestinationName: string;
  public SourceName: string;
  public Multiplier: number;
  public TransactionFee: number;
  public TerminalLocation: string;
  public IsDomestic:boolean;
  public BillAmount: number;
  public BillCurrency:  string;
  public MerchantAccountName: string;
}

export class PayNowDetails extends Serializable{
  public AccountName: string;
  public QrImage: string;
  public UEN: string;
}

export class UploadDocumentInfo extends Serializable {
  UploadRequestNo: number;
  UploadRequestStatus: string;
  UploadReason: string;
  UploadDocType: string;
}

export enum WalletTransactionStatus {
  Initialized = 0,
  Completed = 1,
  Pending = 2,
  Rejected = 3,
  Expired = 4,
  Failed = 5,
  Canceled = 6
}

export enum WalletTransactionMerchantCategoryCode {
  Unknown = -1,
  Commercial = 1,
  Transport = 2,
  Accommodation = 3,
  Utility = 4,
  Retail = 5,
  Fuel = 6,
  Entertainment = 7,
  FnB = 8,
  Insurance = 9,
  FinancialServices = 10,
  Others = 11,
  Government = 12
}

export class BillPaymentDetails {
  public AccountNumber: string;
  public BillCountry: string;
  public BillerCountry: string;
  public BillerId: string;
  public BillerName: string;
  public ProductId: Number;
  public ProductName: string;
  public AdditionalDetails: BillPaymentAdditionalDetails;
  public CategoryType: CategoryType;
  public SubCategoryTypeId: CategoryType;
  public BillerLogoUrl: string;
  public InvoiceDate: string;
  public InvoiceNumber: string;
}

export class BillPaymentAdditionalDetails {
  public Description: string;
}

export class CategoryType {
  public Code: string;
  public Description: string;
}

export class TransactionInfo {
  public transactions: Transaction[];
  public filteredTransactions: Transaction[];
  public totalTransactionCount: number;
  public isFirstTransaction: boolean;
  public NonCanceledFirstTransaction: boolean;
}

export class RecentData {
  public userId: string;
  public transactions: Transaction[];
  public slidesMessages: any[] = [];
  public slidesRecipients: any[] = [];
}
export class TransactionReportAPIInfo {
  public RetVal: number;
  public RetMsg: string;
}

export enum TransactionReportAPIInfoStatus {
  NoPendingRequest = 8118,
  RequestAlreadyExists = 8119,
  ReportRequestedCreatedSuccessfully = 1,
}


// WEBPACK FOOTER //
// ./src/model/myria/app/transaction.ts